import { render, staticRenderFns } from "./update-additional-travellers-combined-products.vue?vue&type=template&id=334f781e"
import script from "./update-additional-travellers-combined-products.vue?vue&type=script&lang=ts"
export * from "./update-additional-travellers-combined-products.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports